const state = {
  isOpen: true,
  noMainMenuFromV4: false
}

const actions = {
  toggle ({ commit }, boolean) {
    commit('toggle', boolean)
  },
  setNoMainMenuFromV4 ({ commit }, boolean) {
    commit('setNoMainMenuFromV4', boolean)
  }
}

const mutations = {
  toggle (state, boolean) {
    state.isOpen = boolean
  },
  setNoMainMenuFromV4 (state, boolean) {
    state.noMainMenuFromV4 = boolean
  }
}

const mainMenu = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default mainMenu
